import axios from 'axios';
import ApiHelper, {API_HELPERS} from "@/helpers/apiHelper";

class AuthService {

    getToken() {
        return axios.post(ApiHelper.getTokenUrl(),
            {
                'contest_id': API_HELPERS.contestId,
            }
        ).then(response => {
            return response.data?.token;
        }).catch(error => {
            return '';
        })
    }



}

export default AuthService;